import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Icn from '../components/Icn';
import Tx from './Tx';

export default function EdgeCardForSelect(props) {

    const { edge, onSelect } = props;

    return (
        <Card key={edge._id} style={{ maxWidth: 173, margin: 5, display: 'inline-block' }}>
            <CardContent>
                <Icn>edge</Icn>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    {edge.number}
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    <Tx>{`device.${edge.deviceType.replace(/_/g, '').toLowerCase()}`}</Tx>
                </Typography>
                <Typography variant="body2" style={{ fontSize: 10 }}>
                    {edge._id}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={() => onSelect(edge._id)}><Tx>edge.add</Tx></Button>
            </CardActions>
        </Card>
    )
}